'use client';

import Link from 'next/link';
import * as S from './styles.ts';
import { CSSProperties, ReactNode } from 'react';

export interface IUniversalLinkProps {
  href: string;
  children?: ReactNode;
  style?: CSSProperties;
  className?: string;
  scroll?: boolean;
  title?: string;
  styled?: boolean;
  target?: string;
}

const UniversalLink = ({
  href,
  children,
  scroll = true,
  title,
  styled,
  target,
  ...props
}: IUniversalLinkProps) => {
  const isInternalLink = href && (href.startsWith('/') || href.startsWith('#'));

  return (
    <S.StyledLink
      $styled={styled}
      target={target}
      as={isInternalLink ? Link : 'a'}
      href={href}
      {...props}
      scroll={isInternalLink ? scroll : undefined}
      title={title}
    >
      {children}
    </S.StyledLink>
  );
};

export default UniversalLink;
